import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "locale", "lang"];
import React, { useEffect, useMemo, useRef, useState, useContext } from 'react';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import { PANDA_EXUI } from "../../const";
import ConfigProvider from "../NextConfigProvider";
import { getNextLocale } from "../../locale/cn-next/3index";
import LocaleContext from "../../context/LocaleContext";
import withI18n from "../../hoc/withI18n";
import $i18n, { init } from "../../i18n/i18n";
import { pandaEvent } from "../../services";
var InPandaConfigProvider = function InPandaConfigProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale,
    lang = _ref.lang,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var context = useContext(LocaleContext);
  // 如果上下文中有翻译，将进行合并
  var localeExtContext = useMemo(function () {
    return isEmpty(context.locale) ? locale : merge({}, context.locale, locale);
  }, [locale, context.locale]);
  var langExtContext = lang || context.lang;
  // 如果上下文中有语种，则使用上下文中的语种
  var _useState = useState(langExtContext || $i18n.getLang()),
    currentLang = _useState[0],
    setCurrentLang = _useState[1];
  var currentLocale = useMemo(function () {
    // 额外使用语言包（使用额外扩展的语言包将不会再合并其他的翻译）
    if (window[PANDA_EXUI] && window[PANDA_EXUI][currentLang]) {
      return window[PANDA_EXUI][currentLang];
    }
    // 如果不存在该语种 使用英文
    return localeExtContext !== null && localeExtContext !== void 0 && localeExtContext[currentLang] ? merge(getNextLocale(currentLang), localeExtContext[currentLang]) : getNextLocale(currentLang);
  }, [currentLang, localeExtContext]);
  // 该$i18n作为configProvider包裹的$i18n实例，有别于cdn实例
  var _$i18n = useMemo(function () {
    return init({
      locale: localeExtContext,
      lang: langExtContext
    });
  }, [langExtContext, localeExtContext]);
  var eventHanderId = useRef('');
  useEffect(function () {
    eventHanderId.current = pandaEvent.on('CHANGE_LANG', function (changedLang) {
      if (!langExtContext) {
        setCurrentLang(changedLang);
      }
    });
    return function () {
      return pandaEvent.off(eventHanderId.current);
    };
  }, [langExtContext]);
  var providerValue = useMemo(function () {
    return {
      locale: localeExtContext,
      lang: langExtContext,
      _lang: currentLang,
      $i18n: _$i18n
    };
  }, [localeExtContext, langExtContext, _$i18n, currentLang]);
  return /*#__PURE__*/React.createElement(ConfigProvider, _extends({}, props, {
    locale: currentLocale
  }), /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: providerValue
  }, children));
};
var PandaConfigProvider = InPandaConfigProvider;
PandaConfigProvider.config = withI18n;
export default PandaConfigProvider;